import styled from 'styled-components';
import checkboxOnImg from 'images/checkbox_on.png';
import checkboxOffImg from 'images/checkbox_off.png';

export const dateInputStyle = {
	background: 'transparent',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    fontSize: 'calc(100vw*(14/375))',
    borderRadius: 'calc(100vw*(5/375))',
    border: 'solid calc(100vw*(1/375)) #d5d5d5',
    '&::placeholder': {
    	 'color': '#c6c6c6'
    },
    '&::focus' :{
    	'border': 'solid calc(100vw*(1/375)) #ffcf19'
    }
}

export const Terminner = styled.div`
    padding: calc(100vw*(79.5/375)) calc(100vw*(17/375)) calc(100vw*(116/375)) calc(100vw*(17/375));
`
export const Maintit = styled.h1`
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
    padding-bottom :  calc(100vw*(14/375));
`
export const Checkboxinner = styled.div`
    padding-top: calc(100vw*(33/375));
`
export const TerminputInner = styled.ul`
    display: flex;
    align-items: center;
`  
export const Ckboxlist = styled.li`
    padding-bottom: calc(100vw*(15/375));
`
export const Ckbox = styled.input`
    display:none;

    &:checked + label > span {
        background-image : url(${checkboxOnImg});
        background-size: calc(100vw*(19/375));
        background-repeat: no-repeat;
    }
`
export const CkWeek = styled.b`
    display:flex;
    align-items: center;
`
export const Ckbox1 = styled(Ckbox)`
    &:checked + label > b span {
        background-image : url(${checkboxOnImg});
        background-size: calc(100vw*(19/375));
        background-repeat: no-repeat;
    }

    &:checked + label > label {
        display:block;
    }
`
export const Marking = styled.label`
    display:none;
`
export const Ckboxlabel = styled.label`
    display: flex;
    align-items: center;
    font-size: calc(100vw*(14/375));
`
export const Ckboxlabel1 = styled(Ckboxlabel)`
    display:block;
`
export const Ckimg = styled.span`
    display:block;
    width: calc(100vw*(19/375));
    height: calc(100vw*(19/375));
    background-image : url(${checkboxOffImg});
    background-size: calc(100vw*(19/375));
    background-repeat: no-repeat;
    margin-right: calc(100vw*(12/375));
`

export const Ckboxnum = styled.input`
    display:block;
    width: calc(100vw*(31.5/375));
    height: calc(100vw*(25/375));
    border-radius: calc(100vw*(3/375));
    border: solid calc(100vw*(1/375)) #d5d5d5;
    background-color: #ffffff;
    margin: 0 calc(100vw*(6/375));
    text-align: center;
    &:focus {
        border: solid calc(100vw*(1/375)) #ffcf19;
    }
`



// 요일선택
export const Weekchoice = styled.ul`
    width: 100%;
    display:flex;
    justify-content: space-between;
    // margin-top : calc(100vw*(18/375));
    // margin-bottom : calc(100vw*(15/375));

    & > ul {
        width: 100%;
    }
` 